import React, { useState } from 'react'
import { Grid } from '@material-ui/core'
import TableFilaAtual from './TableFilaAtual'
import TableAnaliseAtual from './TableAnaliseAtual'
import TablePendendeFilialAtual from './TablePendendeFilialAtual'
import TablePendendeMotoristaAtual from './TablePendendeMotoristaAtual'
import CardsTempoReal from './CardsTempoReal'
import CardsQuantidades from './CardsQuantidades'

const PainelTarefasTempoReal = props => {
  const [fila, setFila] = useState(0)
  const [analise, setAnalise] = useState(0)
  const [pendenteFilial, setPendenteFilial] = useState(0)
  const [pendenteMotorista, setPententeMotorista] = useState(0)

  return (
    <>
      <Grid container spacing={2}>
        <CardsTempoReal {...props} />
        <CardsQuantidades
          {...props}
          quantidadeFila={fila}
          quantidadeAnalise={analise}
          quantidadePendeteFilial={pendenteFilial}
          quantidadePendeteMotorista={pendenteMotorista}
        />
        <TableFilaAtual {...props} setQuantidade={setFila} />
        <TableAnaliseAtual {...props} setQuantidade={setAnalise} />
        <TablePendendeFilialAtual
          {...props}
          setQuantidade={setPendenteFilial}
        />
        <TablePendendeMotoristaAtual
          {...props}
          setQuantidade={setPententeMotorista}
        />
      </Grid>
    </>
  )
}

export default React.memo(PainelTarefasTempoReal)
